import type { SegmentMst } from '@libs/domain';
import { useSegmentMstSettings } from '../hooks';
import { createHigherSegmentMstItem } from '../services';
import { HigherRankSegmentMstSearch } from './highOrderSegmentMstSearch';

export function highOrderAdditionalInfo(segmentMstKey: number) {
  return function Additional<T extends Pick<SegmentMst['schema'], 'higherRankSegmentCode'>>(
    segmentMst: T,
    setSegmentMst: (t: T) => void,
    errorFields?: string[],
  ) {
    const segmentMstSettings = useSegmentMstSettings();

    return segmentMstKey > 1 ? (
      <HigherRankSegmentMstSearch
        obj={segmentMst}
        setObj={setSegmentMst}
        prop="higherRankSegmentCode"
        errorFields={errorFields}
        segmentMstKey={segmentMstKey - 1}
        items={createHigherSegmentMstItem(segmentMstKey, segmentMstSettings)}
      />
    ) : null;
  };
}
